export default __webpack_public_path__ + "static/media/DayPlanner.76385729.png";